import styled from 'styled-components';
import { StyledLinkButton } from '../../../common/components/Button/StyledButtons';
import { HeImgix } from '../../../common/components/images/HeImgix';
import { Col } from '../../../common/components/layout/FlexLayout';
import { Breakpoint } from '../../../common/styles/constants';

export const MoreAboutHealthengineGraphic = styled(HeImgix)`
  height: 100%;
  object-fit: cover;
  object-position: center;
  width: 100%;

  ${Breakpoint.MEDIUM} {
    width: 50%;
  }
`;

export const MoreAboutHealthengineSectionCol = styled(Col)`
  ${Breakpoint.MEDIUM} {
    align-items: flex-start;

    ${StyledLinkButton} {
      margin-top: 24px;
      width: auto;
    }
  }
`;
